export type Entry = 'app' | 'share';

const SHARE_PREFIX = '/s/';

/** `/s/…` é o acompanhamento público: carrega só a própria página, sem sessão, consentimento nem o painel. */
export function resolveEntry(pathname: string): Entry {
  return pathname.startsWith(SHARE_PREFIX) ? 'share' : 'app';
}

export function extractShareToken(pathname: string): string | null {
  if (!pathname.startsWith(SHARE_PREFIX)) return null;
  const [segment] = pathname.slice(SHARE_PREFIX.length).split('/');
  if (!segment) return null;
  try {
    return decodeURIComponent(segment);
  } catch {
    // Codificação quebrada no endereço: tratar como link inválido em vez de derrubar a página.
    return null;
  }
}
